var _g, _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgViewHeaderBanner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 85 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#m79uredfra)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.014,
    width: 85.029,
    height: 59.4,
    rx: 4.714,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#465DD8",
    d: "M.014.471h85.029v24.514H.014z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fill: "#fff",
    d: "M28.3 8.486h26.4v3.771H28.3z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fill: "#fff",
    d: "M17.929 16.029h47.143v1.886H17.929z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.029,
    y: 30.643,
    width: 69.943,
    height: 17.914,
    rx: 1.414,
    stroke: "#EEE",
    strokeWidth: 0.943
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.029,
    y: 54.214,
    width: 69.943,
    height: 17.914,
    rx: 1.414,
    stroke: "#EEE",
    strokeWidth: 0.943
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.486,
    y: 0.471,
    width: 84.086,
    height: 60.457,
    rx: 4.243,
    stroke: "#E5E7EA",
    strokeWidth: 0.943
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "m79uredfra"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.014,
    width: 85.029,
    height: 59.4,
    rx: 4.714,
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewHeaderBanner);
export default __webpack_public_path__ + "static/media/ViewHeaderBanner.72ee5a64.svg";
export { ForwardRef as ReactComponent };